<template>
  <div>
    <v-row>
      <v-col class="d-flex flex-1 align-center justify-space-between">
        <span v-if="venue_hire && venue_hire.branch" class="text-tcdc-green bold text-uppercase sub-header1">{{
          venue_hire.branch.branch_name }}</span>
        <GreenLabel v-if="venue_hire && venue_hire[`manual_url_${lang}`]" :name="$t('venueHire.manual')"
          @onPress="goToManualURL(venue_hire[`manual_url_${lang}`])" />
      </v-col>
    </v-row>
    <template v-if="venue_hire">
      <v-layout v-if="venue_hire.is_show" justify-space-between :column="$vuetify.breakpoint.xs" mt-7 mb-12>
        <v-flex shrink mb-3 mb-sm-0>
          <div v-if="branch_id == 1" class="text-tcdc-green mb-12" style="font-size: 14px">
            <div v-if="lang === 'th'" :class="{ 'text-justify': $vuetify.breakpoint.xs }">
              <p>
                TCDC กรุงเทพฯ ถนนเจริญกรุง บางรัก เปิดให้บริการเช่าพื้นที่
                เพื่อจัดกิจกรรมสร้างสรรค์ และพื้นที่จัดกิจกรรมต่างๆ
                สำหรับบุคคลทั่วไป หน่วยงานภาครัฐ ภาคเอกชน หรือบุคคลที่สนใจ
              </p>
              <p>
                พื้นที่ที่เปิดให้บริการ ได้แก่ ห้องประชุม ห้องสัมมนา ห้องบรรยาย
                Creative Space เริ่มต้นที่ 36 ตร.ม. รองรับตั้งแต่ 12 ถึง 150
                ที่นั่ง พื้นที่ห้องจัดแสดงนิทรรศการ จัดแสดงดนตรี แกลเลอรี่
                จัดแสดงผลงาน โชว์เคส จัดเวิร์กช็อป หลากหลายขนาด พร้อมโปรเจคเตอร์
                และเครื่องเสียง และระบบปรับอากาศให้บริการ
                รวมถึงพื้นที่สำหรับการถ่ายทำภาพยนตร์ ถ่ายทำโฆษณา มิวสิกวิดีโอ
                และพื้นที่ดาดฟ้า (Rooftop) สามารถดูรายละเอียดพื้นที่ต่าง ๆ
                ได้ที่ด้านล่างนี้
              </p>
            </div>
            <div v-else>
              <p>
                TCDC Bangkok, Charoenkrung Bangrak, is providing space rental
                services for creative activities and various types of events for
                the general public, private and public sectors, and those
                interested.
              </p>
              <p>
                The spaces for rent include meeting rooms; spaces for activities
                such as seminars and talks, starting at 36 sq.m. supporting 12 -
                150 seats; rooms for showcases, exhibitions, music performances,
                and workshops of various sizes, with visual and sound system,
                and air conditioning system, along with space for commercial
                purposes such as movies and films, music videos, and spot
                advertising, as well as rooftop space. See more details below.
              </p>
            </div>
          </div>

          <div v-for="(v, i) in ventureList" :key="i" class="d-flex align-center mb-2 sub-header2 bold">
            <v-img v-if="v.img" :src="v.img" contain class="mr-3 shrink" width="30px" height="30px"></v-img>
            <span class="text-tcdc-green text-uppercase">{{
              v[`text_${lang}`]
              }}</span>
          </div>

          <GreenButton label="Book Now" @onPress="onBooking" class="mt-10"></GreenButton>
        </v-flex>
        <v-flex xs8>
          <!--        <div v-for="(venueHireDetail, i) in 1" :key="i">-->
          <div v-for="(venueHireDetail, i) in branch_id == 1
            ? 1
            : venue_hire.venue_hire_details" :key="i">
            <!--          :src="venueHireDetail[0].floor.image_url"-->
            <!--          :src="require('../../assets/Map.png')"-->
            <v-img :src="branch_id == 1
              ? require('../../assets/Map.png')
              : venueHireDetail[0].floor.image_url
              " width="100%" style="position: relative">
              <!--       <pre>{{venueHireDetail[0]}}</pre>-->
              <template v-slot:placeholder>
                <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>
              </template>

              <div v-if="branch_id == 1">
                <img v-for="(style, ind) in tcdcBangkokMarks" :key="ind" :src="require('../../assets/Location.svg')"
                  alt="location-mark" class="cursor-pointer tcdcbangkok-marker" style="position: absolute" :style="{
                    top: style.top,
                    left: style.left,
                    right: style.right,
                    bottom: style.bottom,
                  }" @click="onOpen(style.floor_index, style.id)" />
              </div>
            </v-img>
          </div>
        </v-flex>
      </v-layout>

      <v-row v-if="branch_id === 1" class="mt-3">
        <v-col>
          <youtube v-if="videoId" :video-id="videoId" ref="youtube" :player-vars="playerVars" width="100%"
            height="500px">
          </youtube>
        </v-col>
      </v-row>

      <div class="mb-5 mt-10">
        <span class="text-tcdc-green sub-header2 bold mr-5" style="display: inline-block">
          {{ $t("venueHire.service") }}
        </span>
        <v-select id="venueHireType" v-if="venueHireType && venueHireType.length > 1"
          class="text-uppercase service-area-select" style="color: #2e8037; display: inline-block" outlined dense
          rounded menu-props="offset-y" color="#2e8037" item-color="#2e8037" placeholder="Sort by:" v-model="sortBy"
          :items="venueHireType" :item-text="returnTextSelect" item-value="type_id" hide-details
          @change="venuehireFilter" append-icon="mdi-menu-down"></v-select>
      </div>
      <Divider />
      <!-- <div
        v-if="sortBy !== 0 && venue_hire_filtered.length < 1"
        class="py-10 text-center grey--text"
      >
        {{ $t("venueHire.itemNotFound") }}
      </div> -->
      <template v-for="(venueHireDetail, i) in sortBy == 0
        ? venue_hire_new_for_show
        : venue_hire_new_for_show.filter(
          (x) => x.venue_hire_type_id === sortBy
        )">
        <div :key="i" class="py-10 venture-tcdc-border-green" v-if="venueHireDetail.rooms.length > 0">
          <div class="text-tcdc-green sub-header2 bold mb-2">
            {{ venueHireDetail.name_th + ': ' + venueHireDetail.name_en }}
          </div>
          <v-row>
            <template v-for="x in venueHireDetail.rooms">
              <v-col cols="12" md="4" :key="x.id">
                <FloorCard :title="x[`name_${lang}`]" :content="x[`description_${lang}`]" :slides="x.slide_images"
                  :enable-button="true" @onBooking="onBooking" />
              </v-col>
            </template>
          </v-row>
        </div>
      </template>
      <v-row class="mt-10">
        <v-col cols="12" md="10"></v-col>
      </v-row>
      <v-row class="pt-10" id="contact-venuehire">
        <v-col class="mt-5" cols="12" md="10">
          <SendMessageForm @onSubmit="sendMsg" />
          <AlertModal :show="modal" :message="modalMsg" @onConfirm="modal = false"></AlertModal>
        </v-col>
      </v-row>
      <RoomModal :visible="visible" :data="floorModalData" @onClose="onClose" />
    </template>
    <!-- <template v-for="(venueHireDetail, i) in sortBy === 0 ? venue_hire.venue_hire_details:venue_hire_filtered">
         <div :key="i" class="py-10 venture-tcdc-border-green">
           <span v-if="venueHireDetail[0].floor" class="text-tcdc-green sub-header2 bold">
             {{venueHireDetail[0].floor.floor_name}}
           </span>
             <v-row>
               <template v-for="x in venueHireDetail">
                 <v-col cols="12" md="4" :key="x.id">
                   <FloorCard
                           :title="x[`name_${lang}`]"
                           :content="x[`description_${lang}`]"
                           :slides="x.slide_images"
                           :enable-button="true"
                           @onBooking="onBooking"
                   />
                 </v-col>
               </template>
             </v-row>
           </div>
         </template>
         <v-row class="mt-10">
           <v-col cols="12"
                  md="10">
           </v-col>
         </v-row>
         <v-row class="pt-10" id="contact-venuehire">
           <v-col class="mt-5" cols="12" md="10">
             <SendMessageForm @onSubmit="sendMsg" />
             <AlertModal
                     :show="modal"
                     :message="modalMsg"
                     @onConfirm="modal = false"
             ></AlertModal>
           </v-col>
         </v-row>
         <RoomModal :visible="visible" :data="floorModalData" @onClose="onClose" />
       </template> -->
  </div>
</template>

<script>
import GreenLabel from "../../components/labels/GreenLabel";
import Divider from "../../components/dividers/Divider";
import FloorCard from "../../components/cards/FloorCard";
import RoomModal from "@/components/modals/RoomModal";
import SendMessageForm from "../../components/form/SendMessageForm";
import AlertModal from "../modals/AlertModal";
import { mapState } from "vuex";
import GreenButton from "../../components/buttons/GreenButton.vue";

export default {
  props: ["sortBy"],
  components: {
    GreenLabel,
    Divider,
    FloorCard,
    SendMessageForm,
    AlertModal,
    RoomModal,
    GreenButton,
  },
  data: () => ({
    visible: false,
    // sortBy: 0,
    venue_hire_filtered: [],
    floorModalData: [],
    tcdcBangkokMarks: [
      {
        // mapping with api
        floor_index: 0,
        id: 7,
        // mark location
        top: "4.5%",
        left: "34%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 0,
        id: 34,
        // mark location
        top: "4.8%",
        left: "59%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 0,
        id: 1,
        // mark location
        top: "7.5%",
        left: "50%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 0,
        id: 8,
        // mark location
        top: "11.5%",
        left: "60%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 1,
        id: 9,
        // mark location
        top: "19.5%",
        left: "33.4%",
        right: "0",
        bottom: "0",
      },
      // {
      //   // mapping with api
      //   floor_index: 1,
      //   id: 35,
      //   // mark location
      //   top: "20%",
      //   left: "68.4%",
      //   right: "0",
      //   bottom: "0",
      // },
      {
        // mapping with api
        floor_index: 2,
        id: 36,
        // mark location
        top: "30.1%",
        left: "35.2%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 2,
        id: 12,
        // mark location
        top: "31.2%",
        left: "31%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 2,
        id: 11,
        // mark location
        top: "32.4%",
        left: "26.6%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 2,
        id: 10,
        // mark location
        top: "33.5%",
        left: "22.5%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 3,
        id: 13,
        // mark location
        top: "45.4%",
        left: "68.6%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 4,
        id: 21,
        // mark location
        top: "62%",
        left: "33.5%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 4,
        id: 20,
        // mark location
        top: "64%",
        left: "25.4%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 5,
        id: 15,
        // mark location
        top: "75.6%",
        left: "73.9%",
        right: "0",
        bottom: "0",
      },
      {
        // mapping with api
        floor_index: 5,
        id: 14,
        // mark location
        top: "78.8%",
        left: "23.8%",
        right: "0",
        bottom: "0",
      },
    ],
    modal: false,
    modalMsg: "",
    ventureList: [
      {
        text_th: "พื้นที่ให้เช่า",
        text_en: "Space Rentals Area",
        img: require("../../assets/icons/venue_hire/venue-hire.png"),
      },
      {
        text_th: "ลิฟท์",
        text_en: "Elevator",
        img: require("../../assets/icons/venue_hire/elevator.png"),
      },
      {
        text_th: "บันได",
        text_en: "Staircase",
        img: require("../../assets/icons/venue_hire/staircase.png"),
      },
      {
        text_th: "บันไดเลื่อน",
        text_en: "Escalator",
        img: require("../../assets/icons/venue_hire/escalator.png"),
      },
    ],
    videoId: "",
  }),
  created() {
    this.getVenueHireByBranch();
    this.$store.dispatch("VenueHire/onGetVenueHireType");
    // console.log(this.venueHireType);
    // console.log("this.venue_hire_new_for_show",this.venue_hire_new_for_show);
    // console.log(this.iconSortBy)
  },
  computed: {
    ...mapState({
      venue_hire: (state) => state.ServiceMenu.venture_hire,
      venue_hire_new_for_show: (state) => {
        let result = [];
        let allRooms = [].concat(
          ...state.ServiceMenu.venture_hire.venue_hire_details
        );
        // console.log("allRooms : ", allRooms);
        if (state.Branch.branch_id === 1) {
          let room_model = [
            [9, 34],
            [1, 21, 22, 13, 20],
            [10, 11, 36, 12],
            [7, 8, 14, 15],
          ];

          result = state.VenueHire.venue_hire_type?.map((item, index) => {

            let rooms = room_model.map((model) => {
              return allRooms.filter((room) => model.includes(room.id));
            });

            return {
              venue_hire_type_id: item.type_id,
              name_th: item.name_th,
              name_en: item.name_en,
              rooms: rooms[index],
            };
          });

          let newOrder = []
          let reorder = [2, 1, 4, 3]

          for (const x of reorder) {
            newOrder.push(result.find(y => y.venue_hire_type_id === x))
          }
          result = newOrder
        } else {
          for (const venue_hire_type of state.VenueHire.venue_hire_type) {
            result.push({
              venue_hire_type_id: venue_hire_type.type_id,
              name_th: venue_hire_type.name_th,
              name_en: venue_hire_type.name_en,
              rooms: allRooms.filter((x) =>
                x.venue_hire_type_id.includes(venue_hire_type.type_id)
              ),
            });
          }
        }
        return result;
      },
      branch_id: (state) => state.Branch.branch_id,
      branchName: (state) => state.Branch.branch_name,
      lang: (state) => state.Branch.lang,
      venueHireType: (state) => {
        if (state.VenueHire.venue_hire_type) {
          let newOrder = []
          let reorder = [2, 1, 4, 3]

          for (const x of reorder) {
            newOrder.push(state.VenueHire.venue_hire_type.find(y => y.type_id === x))
          }
          return [
            { name_en: "Show all", name_th: "แสดงทั้งหมด", type_id: 0 },
            ...newOrder,
          ];
        }
      },
    }),
  },
  methods: {
    async getVenueHireByBranch() {
      let lang = this.lang;
      let id = this.branch_id;
      try {
        let res = await this.$store.dispatch("VenueHire/onGetVenueHire", { lang: lang, branch_id: id });
        if (res) {
          if (id === 1) {
            this.videoId = res.youtube_url.split("v=")[1];
          } else {
            this.videoId = "-lpGBZtrAYc";
          }
        } else {
          this.videoId = "-lpGBZtrAYc";
        }
      } catch (error) {
        console.log(error);
      }
    },
    returnTextSelect(item) {
      if (!item.type_id) {
        return item.name_th;
      }
      return item.name_th + ": " + item.name_en;
    },
    onOpen(floor_index, id) {
      let data = this.venue_hire.venue_hire_details[floor_index].find(
        (x) => x.id == id
      );
      this.floorModalData = data;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    goToManualURL(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    onBooking() {
      this.$vuetify.goTo("#contact-venuehire");
    },
    venuehireFilter() {
      // console.log("this.venue_hire_new_for_show");
      // console.log(this.venue_hire_new_for_show);
      // let result = [];
      // let floorResult = [];
      // let roomResult = [];
      // for (const floor of this.venue_hire.venue_hire_details) {
      //   for (const room of floor) {
      //     if (
      //       room.venue_hire_type_id &&
      //       room.venue_hire_type_id.length > 0 &&
      //       room.venue_hire_type_id.includes(this.sortBy)
      //     ) {
      //       // console.log('room floor', room.floor.floor_name, 'type', room.venue_hire_type_id.toString())
      //       roomResult.push(room);
      //     }
      //   }
      //   if (roomResult.length > 0) {
      //     floorResult.push(roomResult);
      //     roomResult = [];
      //   }
      // }
      // if (floorResult.length > 0) {
      //   result = floorResult;
      //   floorResult = [];
      // }
      // console.log('filter', result)
      // this.venue_hire_filtered = result;
    },
    sendMsg(form) {
      form.branch_id = this.branch_id;
      if (form.email && form.phone) {
        this.$store.dispatch("Contact/sendMsgVenueHire", form).then(() => {
          this.modalMsg = this.$t("messageBox.success");
          this.modal = true;
        });
      } else {
        this.modalMsg = this.$t("messageBox.notValid");
        this.modal = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.venture-tcdc-border-green {
  border-bottom: 2px solid $tcdcGreen;
}

.venture-tcdc-border-green:last-child {
  border-bottom: 0px solid white !important;
}

.tcdcbangkok-marker {
  width: 21px;
  aspect-ratio: 1;
}

@media (min-width: 960px) {
  .tcdcbangkok-marker {
    width: 30px;
  }
}

.tcdcbangkok-marker:hover {
  animation: jump 1s infinite;
  -webkit-animation: jump 1s infinite;
}

@keyframes jump {
  0% {
    transform: translateY(0%);
  }

  50% {
    transform: translateY(-16%);
  }

  100% {
    transform: translateY(0%);
  }
}

@-webkit-keyframes jump {
  0% {
    transform: translateY(0%);
  }

  50% {
    transform: translateY(-16%);
  }

  100% {
    transform: translateY(0%);
  }
}
</style>
